module.exports = __webpack_public_path__ + "static/media/apartment3.6d230627.jpg";